import AssistantChat from './AssistantChat';
import ChatSessionHeader from './ChatSessionHeader';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';

/**
 * Drawer component for the AI Assistant (overlay version)
 *
 * Controlled component - parent manages open/close state.
 * Uses portal to render outside parent stacking context.
 *
 * Chat state is managed in AssistantProvider context, so it persists
 * across React Router navigations.
 */
const AssistantDrawer = ({ isOpen, onClose }) => {
    return createPortal(
        <>
            {/* Overlay */}
            <div
                className={`
          fixed inset-0 bg-black/30 z-[1001] transition-all duration-300
          ${isOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}
        `}
                onClick={onClose}
            />

            {/* Panel */}
            <div
                className={`
          fixed bottom-0 right-0 w-[400px] h-[600px] max-h-[calc(100vh-40px)]
          bg-white rounded-t-xl shadow-xl z-[1002] flex flex-col
          transition-transform duration-300 ease-out
          max-sm:w-full
          ${isOpen ? 'translate-y-0' : 'translate-y-full'}
        `}
            >
                <ChatSessionHeader onClose={onClose} />
                <div className="flex-1 overflow-hidden">
                    <AssistantChat />
                </div>
            </div>
        </>,
        document.body,
    );
};

AssistantDrawer.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default AssistantDrawer;
